/**
 * Thin wrapper around Umami analytics.
 * Umami script is loaded via <script> tag in index.html.
 * All methods are safe to call even if the script hasn't loaded yet.
 */

interface UmamiTracker {
  track: (event: string, data?: Record<string, unknown>) => void;
  identify: (data: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    umami?: UmamiTracker;
  }
}

export function track(event: string, data?: Record<string, unknown>): void {
  window.umami?.track(event, data);
}

export function identify(data: Record<string, unknown>): void {
  window.umami?.identify(data);
}
